import React from "react";
import { useTranslation, Link } from "gatsby-plugin-react-i18next";

import * as styles from "../../assets/sass/modules/_sub-menu.module.scss";

const MenuDevision = () => {
  const { t } = useTranslation();

  return (
    <div className="container">
      <div className={styles.menuPanel}>
        <div className="row">
          <div className={`${styles.menuGroup} col-12 col-lg-6`}>
            <div className={styles.category}>{t("WHY_DEVISION")}</div>
            <p className="featureDescription">
              {t("WHY_DEVISION_DESCRIPTION")}
            </p>
          </div>
          <div className={`${styles.menuGroup} col-12 col-lg-6`}>
            <ul className={`${styles.linkList} row`}>
              <li className="col-12 col-lg-6" key="1">
                <Link to="/our-approach" className={styles.category}>
                  {t("OUR_APPROACH")}
                </Link>
              </li>
              <li className="col-12 col-lg-6" key="2">
                <Link to="/our-company" className={styles.category}>
                  {t("OUR_COMPANY")}
                </Link>
              </li>
              <li className="col-12 col-lg-6" key="3">
                <Link to="/our-team" className={styles.category}>
                  {t("OUR_TEAM")}
                </Link>
              </li>
              <li className="col-12 col-lg-6" key="4">
                <Link to="/blog" className={styles.category}>
                  {t("OUR_BLOG")}
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MenuDevision;
